import { RoleProtected } from '../Components/RoleProtected';
import SmartButtonView from '../Components/SmartButtonsPageComp/Views/SmartButtonsView';

export default function SmartButtonsPage() {
  return (
    <RoleProtected allowedRoles={["user", "Admin"]} showPageAction="smart_buttons_view">
      <SmartButtonView />
    </RoleProtected>
  );
}